import { isNonEmpty } from 'fp-ts/Array';
import { useMemo } from 'react';
import { useSafeUrlState } from '@mews/framework';
import { accountMergeUrlQueryParamSchema } from '../schema';
import { useTotalMatchingGuestProfileHistory } from '../store/accountMergeStore';
import { MergeMode } from '../types';

export const useAccountMergeState = () => {
    const [urlState] = useSafeUrlState(accountMergeUrlQueryParamSchema);
    const { cursor, previousMatchId, totalProfileMatches } = useTotalMatchingGuestProfileHistory();

    return useMemo(() => {
        const guestProfileIds =
            urlState?.customerId && urlState?.otherCustomerId ? [urlState.customerId, urlState.otherCustomerId] : [];
        const mergeMode = isNonEmpty(guestProfileIds) ? MergeMode.Single : MergeMode.Queue;

        return {
            cursor,
            guestProfileIds: guestProfileIds || [],
            mergeMode,
            previousMatchId,
            totalProfileMatches: totalProfileMatches || 0,
        };
    }, [cursor, previousMatchId, totalProfileMatches, urlState?.customerId, urlState?.otherCustomerId]);
};
